import React from "react";
import cn from "classnames";
import { DropTarget } from "react-dnd";
import { ReactComponent as DropSvg } from "@/assets/img/drop.svg";

function DropDiv({ isOver, canDrop, connectDropTarget }) {
  const isActive = isOver && canDrop;

  return connectDropTarget(
    <div
      className={cn({
        "dnd-dropper-zone": true,
        canDrop,
        isActive,
      })}>
      <DropSvg />
    </div>,
  );
}

export default DropTarget(
  props => props.acceptsType,
  {
    drop({ onDrop }) {
      onDrop();
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(DropDiv);
